/**
 * @generated SignedSource<<f9e6f72290f59805c46c159e89ae5a3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_servicedeskSettingsVirtualAgentLanding_LandingPage_featuresRef$data = {
  readonly isVirtualAgentAvailable: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef" | "header_servicedeskSettingsVirtualAgentLanding">;
  readonly " $fragmentType": "main_servicedeskSettingsVirtualAgentLanding_LandingPage_featuresRef";
};
export type main_servicedeskSettingsVirtualAgentLanding_LandingPage_featuresRef$key = {
  readonly " $data"?: main_servicedeskSettingsVirtualAgentLanding_LandingPage_featuresRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_servicedeskSettingsVirtualAgentLanding_LandingPage_featuresRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "checkForAiEnabledFF"
    }
  ],
  "kind": "Fragment",
  "name": "main_servicedeskSettingsVirtualAgentLanding_LandingPage_featuresRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isVirtualAgentAvailable"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "checkForAiEnabledFF",
          "variableName": "checkForAiEnabledFF"
        }
      ],
      "kind": "FragmentSpread",
      "name": "actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef"
    },
    {
      "kind": "FragmentSpread",
      "name": "header_servicedeskSettingsVirtualAgentLanding"
    }
  ],
  "type": "VirtualAgentFeatures"
};

(node as any).hash = "f1647a589d77acb6751c97b7aa499ccd";

export default node;
